import styled from "styled-components";

export const Container = styled.div<{
	scale: number;
	left: number;
	bottom: number;
	show: boolean;
}>`
	position: fixed;
	bottom: ${(props) => props.bottom}px;
	left: ${(props) => props.left}px;
	transform: scale(${(props) => props?.scale});
	transform-origin: bottom left;
	display: flex;
	justify-content: flex-start;
	align-items: center;
	opacity: ${(props) => (props.show ? 1 : 0)};
`;
